import SEO from "../seo/SEO";

export default function NotFound() {
  return (
    <div className="legal">
      <SEO
        title="Seite nicht gefunden - 404"
        description="Die gesuchte Seite existiert nicht. Zurück zur Startseite der Pferdeosteopathie Laskowski in Hamburg."
        noindex
      />
      <h1>Seite nicht gefunden</h1>
      <p>
        Die von Ihnen aufgerufene Seite existiert leider nicht oder wurde
        verschoben.
      </p>
      <p>
        <a href="/">Zurück zur Startseite</a>
      </p>
    </div>
  );
}
